'use strict';

angular.module('internal.inspections')
    .directive('internalInspectionHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'inspections/components/inspection-header/inspection-header.html',
            controller: 'InternalInspectionHeader',
            replace: true
        };
    }])
    .controller('InternalInspectionHeader', ['$scope', '$filter', function ($scope, $filter) {
        $scope.showDocuments = function (documents) {
            var len = documents.length;
            for (var i = 0; i < len; i++) {
                if (documents[i].document_type != null && documents[i].document_type.other && documents[i].document_type.name != 'Inspection Checklist') {
                    return true;
                }
            }

            return false;
        };

        $scope.shouldDisplay = function (document) {
            if (document == undefined || document.document_type === null) return false;

            return document.name != $scope.inspection.number && document.document_type.other;
        };

        $scope.shouldAddComma = function (index) {
            var len = $scope.inspection.documents.length;
            for (var i = index + 1; i < len; i++) {
                if ($scope.shouldDisplay($scope.inspection.documents[i])) {
                    return true;
                }
            }

            return false;
        };  

    }])
;